import { IUpdateObraEstruturaOrganizacionalUseCase } from "../../../presentation/useCases/update/update_obra_estrutura_organizacional_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateObraEstruturaOrganizacionalUseCase
 */

export class UpdateObraEstruturaOrganizacionalUseCase implements IUpdateObraEstruturaOrganizacionalUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObraEstruturaOrganizacional(
    idEstruturaOrganizacional: number,
    idFuncionario: number,
    idCargo: number,
  ): Promise<void> {
    await this.repository.updateObraEstruturaOrganizacional(
      idEstruturaOrganizacional,
      idFuncionario,
      idCargo,
    );
  }
}
